import { render, staticRenderFns } from "./filters-accordion.vue?vue&type=template&id=0b38ce34&"
import script from "./filters-accordion.vue?vue&type=script&lang=js&"
export * from "./filters-accordion.vue?vue&type=script&lang=js&"
import style0 from "./filters-accordion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports